/*
 * Layout
 * ------
 */

/* Imports */

import React, { useLayoutEffect } from "react";
import { Helmet } from "react-helmet";
import "../../../../styles/pages.scss";
import { subscribe, publish } from "../../../../latercon/2021/base/pub-sub";
import globals from "../../../../latercon/2021/base/variables";
import Loader from "../../../../latercon/2021/components/Loader";
import Header from "../../../../latercon/2021/components/Header";
import Footer from "../../../../latercon/2021/components/Footer";
import Banner from "../../../../latercon/2021/components/Banner";

/* Page */

const Layout = ({
  registrationClosed = false,
  eventPassed = false,
  ctaText = "",
  children,
}) => {
  /* Event is done */

  const eventDone = registrationClosed || eventPassed;

  /* Banner text */

  let bannerComponent = "";

  if (eventDone) {
    const bannerText = (
      <>
        {eventPassed ? "Event has passed" : "Registration has closed"}{" "}
        <span aria-hidden="true">|</span> Sign up for our newsletter to stay up
        to date on future events
      </>
    );

    bannerComponent = <Banner text={bannerText} />;
  }

  /* Animate on visible in viewport */

  useLayoutEffect(() => {
    if (globals.ioSupported) {
      const visItems = Array.from(document.querySelectorAll(".lc-vis"));

      const oi = ({
        item = null,
        setItem = null,
        visible = false,
        all = false,
        threshold = 0.3,
        delay = 0,
        done = false,
        donePub = "",
        toggle = false,
      }) => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (!visible) {
                  setTimeout(() => {
                    if (all) {
                      setItem.setAttribute("data-vis-all", true);
                    } else {
                      setItem.setAttribute("data-vis", true);
                    }

                    visible = true;

                    if (done) {
                      setTimeout(() => {
                        globals[donePub] = true;
                        publish(donePub);
                      }, done);
                    }
                  }, delay);
                }
              } else if (toggle) {
                if (visible) {
                  setTimeout(() => {
                    if (all) {
                      setItem.setAttribute("data-vis-all", false);
                    } else {
                      setItem.setAttribute("data-vis", false);
                    }

                    visible = false;
                  }, delay);
                }
              }
            });
          },
          { threshold }
        );

        observer.observe(item);
      };

      if (visItems.length) {
        visItems.forEach((it) => {
          const args = {
            item: it,
            setItem: it,
            visible: false,
            all: it.hasAttribute("data-v-all"),
            delay: parseInt(it.getAttribute("data-delay"), 10),
            done: parseInt(it.getAttribute("data-v-done"), 10),
            donePub: it.getAttribute("data-v-done-pub"),
            toggle: false,
          };

          if (it.hasAttribute("data-th"))
            args.threshold = parseFloat(it.getAttribute("data-th"));

          if (it.getAttribute("data-v-toggle") === "true") args.toggle = true;

          if (it.getAttribute("data-v-item")) {
            const vItem = document.querySelector(
              it.getAttribute("data-v-item")
            );

            if (vItem) args.item = vItem;
          }

          if (globals.loaderDone) {
            oi(args);
          } else {
            subscribe("loaderDone", () => {
              oi(args);
            });
          }
        });
      }
    }
  }, []);

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="https://use.typekit.net/vyn2beg.css" />
        <script>
          {`// Variables
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({'branch': ""});
          `}
        </script>
      </Helmet>

      <Loader />

      {bannerComponent}

      <div className="lc-p-r" data-disable-links={eventDone.toString()}>
        <Header ctaText={ctaText} />

        <main>{children}</main>

        <Footer />
      </div>
    </>
  );
};

/* Export */

export default Layout;
